/** @format */
const { getTransitionScreens } = require("../config/screens/transition");
const { getVerifyScreens } = require("../config/screens/verify");
const { getOcrScreens } = require("../config/screens/ocr");

function verifyStandaloneFlow(i18n) {
  return [
    {
      path: "/chapter1",
      params: {
        title: () => i18n.t("overview:step_one"),
      },
      screens: [
        ...getVerifyScreens({
          i18n,
          screens: [{ name: "methodsIntro" }],
        }),
      ],
    },
    {
      path: "/chapter2",
      params: {
        title: () => i18n.t("overview:step_two"),
      },
      screens: [
        ...getOcrScreens({
          i18n,
          screens: [
            {
              name: "ocr",
              params: {
                noSpacing: true,
              },
            },
          ],
        }),
      ],
    },
    {
      path: "/chapter3",
      params: {
        title: () => i18n.t("overview:step_three"),
      },
      screens: [
        ...getTransitionScreens({
          i18n,
          screens: [{ name: "transitionVerifyGreat" }],
        }),
      ],
    },
  ];
}

module.exports = verifyStandaloneFlow;



// WEBPACK FOOTER //
// ./src/partners/variant-flows/verify.js